export default {
    hasPermission(app, module, action = 'view') {
        const userStr = localStorage.getItem('currentUser');
        if (!userStr) return false;

        const user = JSON.parse(userStr);

        // Admin has all permissions
        if (user.role === 'admin') return true;

        // Strict check: permissions must be under the app key
        if (!user.permissions || !user.permissions[app]) return false;

        const modulePerms = user.permissions[app][module];
        if (!modulePerms) return false;

        return modulePerms.includes(action);
    },

    hasAppAccess(app) {
        const userStr = localStorage.getItem('currentUser');
        if (!userStr) return false;
        const user = JSON.parse(userStr);
        if (user.role === 'admin') return true;

        if (!user.permissions || !user.permissions[app]) return false;

        // Return true if has any view permission in any module of this app
        return Object.values(user.permissions[app]).some(actions => actions.includes('view'));
    }
};
